import React, { memo } from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import { useResolvedTheme, TOAST_LAYER } from "@xsolla/xui-core";
import { Toast } from "./Toast";
import type { ToastGroupProps } from "./types";

const TOAST_GROUP_CONFIG = {
  containerPadding: 12,
  groupGap: 8,
};

export const ToastGroup = memo(
  ({
    toasts,
    position = "top",
    maxWidth,
    onDismiss,
    testID,
    themeMode,
    themeProductContext,
  }: ToastGroupProps) => {
    useResolvedTheme({ themeMode, themeProductContext });
    const config = TOAST_GROUP_CONFIG;

    if (toasts.length === 0) {
      return null;
    }

    const positionStyles =
      position === "top"
        ? { top: config.containerPadding, bottom: undefined }
        : { top: undefined, bottom: config.containerPadding };

    return (
      <Box
        testID={testID}
        position="absolute"
        left={0}
        right={0}
        zIndex={TOAST_LAYER}
        alignItems="center"
        paddingHorizontal={config.containerPadding}
        pointerEvents="box-none"
        {...positionStyles}
      >
        <Box
          width="100%"
          maxWidth={maxWidth}
          gap={config.groupGap}
          flexDirection="column"
        >
          {toasts.map((toast) => (
            <Toast
              key={toast.id}
              id={toast.id}
              type={toast.type}
              title={toast.title}
              description={toast.description}
              descriptionLines={toast.descriptionLines}
              icon={toast.icon}
              action={toast.action}
              showCloseButton={toast.showCloseButton}
              progress={toast.progress}
              duration={toast.duration}
              onClose={() => onDismiss(toast.id)}
            />
          ))}
        </Box>
      </Box>
    );
  }
);

ToastGroup.displayName = "ToastGroup";
